const coverage_values = {
  id: "",
  status: false,
  routeId: [],
  courierId: [],
  shippingType: [],
  deliveryType: "",
  leadtime: {},
  workingTime: [
    {
      daysOfWeek: [],
      from: new Date(),
      to: new Date(),
    },
  ],
  pickupDays: [],
  deliveryDays: [],
  scheduleRules: [
    {
      receptionTime: { from: "", to: "", daysOfWeek: [] },
      deliveryTime: { offset: { value: 0, unit: "m" }, fixedHour: "", label: "" },
    }
  ],
  cost: [
    {
      key: "",
      value: 0,
    },
  ],
}

export default coverage_values
